module.exports = __webpack_public_path__ + "static/media/aquarius-logo-large.9cf17928.svg";